module.exports = __webpack_public_path__ + "img/map.ac064ca0.gif";